import { VoidCallback1 } from '@deqo/foundation';
import { injectable } from 'inversify';

import { ReadStore } from './ReadStore';

@injectable()
export abstract class WriteStore<T> extends ReadStore<T> {

    public update(mutator: VoidCallback1<T>): T;
    public update(update: Partial<T>): T;
    public update(input: any) {
        return this.mutate(input);
    }

    public updateTo(newState: T) {
        return this.mutateTo(newState);
    }
}
